import {API_ROOT_URL} from 'envs/_current/config'
import _ from 'lodash'
import {createAsyncAction} from 'modules/asyncCache'
import Request from './middleware/request'

export * from './announcement'
export * from './apps'
export * from './article'
export * from './auth'
export * from './billing'
export * from './bookmarks'
export * from './calendar'
export * from './church'
export * from './profile'
export * from './category'
export * from './channel'
export * from './chart'
export * from './comment'
export * from './contact'
export * from './course'
export * from './document'
export * from './errorReport'
export * from './exam'
export * from './host'
export * from './image'
export * from './keyword'
export * from './location'
export * from './medal'
export * from './member'
export * from './message'
export * from './music'
export * from './notification'
export * from './organization'
export * from './organizationPartner'
export * from './participant'
export * from './payments'
export * from './permission'
export * from './pin'
export * from './poll'
export * from './post'
export * from './referral'
export * from './role'
export * from './search'
export * from './subscription'
export * from './systems'
export * from './test'
export * from './topic'
export * from './url-link'
export * from './user'
export * from './vote'
export * from './feedback'
export * from './religiousOrder'
export * from './yellowPage'
export * from './missal'
export * from './dictionary'
export * from './workingApp'
export * from './studentLink'
export * from './account'
export * from './shop'
export * from './spirituality'
export * from './examen'
export * from './discernment'
export * from './retreat'
export * from './devotion'
export * from './entityRole'
export * from './curriculum'
export * from './modelAudit'
export * from './group'
export * from './timetable'

export function postRequest({url, data}) {
    return Request.post(`${API_ROOT_URL}/${url}/info`, data)
    // return new Promise(resolve => {
    // 	setTimeout(() => resolve({ status: 400 }), 1000)
    // })
}

export const create_loadMore_Api_action = ({
                                               prefixStr,
                                               path,
                                               apiInfo,
                                               ...rest
                                           }) =>
    createAsyncAction({
        asyncId: `${prefixStr}/loadmore/${path}`,
        apiInfo: {
            ..._.omit(apiInfo, ['root']),
            path,
        },
        ...rest,
    })
